import { DateTime } from "luxon";
const selectOptionsControls = (pickedDate, currentInterval, currentTimeByTimeZone, timeZone) => {
    if (!pickedDate || !currentInterval || !currentTimeByTimeZone) return false;

    const toDT = (v) => {
        if (DateTime.isDateTime(v)) return v;
        if (typeof v === "string") return DateTime.fromISO(v, { setZone: true });
        if (v instanceof Date) return DateTime.fromJSDate(v);
        return null;
    };

    let nowDT = toDT(currentTimeByTimeZone);
    let pickDT = toDT(pickedDate);
    if (!nowDT || !pickDT) return false;
    const zoneName = timeZone || nowDT.zoneName;
    nowDT = nowDT.setZone(zoneName);
    pickDT = pickDT.setZone(zoneName);

    const thresholds = {
        "30m": nowDT.plus({ minutes: 30 }),
        "1h" : nowDT.plus({ hours: 1 }),
        "2h" : nowDT.plus({ hours: 2 }),
        "3h" : nowDT.plus({ hours: 3 }),
        "1d" : nowDT.plus({ days: 1 }),
        "3d" : nowDT.plus({ days: 3 }),
    };

    const bound = thresholds[currentInterval];
    if (!bound) return false;

    return pickDT.toMillis() > bound.toMillis();
};

export default selectOptionsControls;
